<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Live Sessions</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
				
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-overlay :show="this.working" rounded="sm">
			<div class="row">
				<div class="col-md-3">
					<div class="leftSide">
						<b-table striped hover small :items="sessions" selectable select-mode="single" :fields="['startedDateTime']" @row-clicked="onSessionSelected"></b-table>					
					</div>
				</div>
				<div class="col-md-8 m-3 mt-0" v-if="session">
					<div class="messages-panel" ref="session.messages">

						<div :class="'message message-' + (m.inbound ? 'in' : 'out') + ' m' + index + 'of' + session.messages.length" v-for="(m, index) in session.messages" :key="m.id">
							{{ m.body }}<br><b-button class="context-button" size="sm" variant="link" @click="alert(m.body)">...</b-button>
							<div>{{ m.sentDateTime }}</div>
						</div>

						<div ref="lastMessage"></div>

						</div>

						<div class="send-area" ref="sendArea">
						<b-input-group>
							<b-form-textarea @focus="forceScroll()" name="message" id="message"
								data-lpignore="true" autocomplete="false" style="height: 80px;"
								v-model="message.body">
							</b-form-textarea>
							<template #append>
								<b-button style="height: 40px !important;" :disabled="message.body == ''" @click="sendMessage" variant="success"><b-icon icon="play-fill"></b-icon></b-button>
							</template>
						</b-input-group>
						<br/><br/>
						Chatting with {{ customer.person.firstName }} {{ customer.person.lastName }} {{ customer.person.dob.split('T')[0] }} {{ customer.person.email }}
						<br/><br/>
						<b-button class="template-button" @click="sendIntro" variant="success">Intro</b-button>
						<b-button class="template-button" @click="sendReviewing" variant="success">Send Reviewing Message</b-button>
						<b-button class="template-button" @click="requestPersonalData" variant="success">Request Personal Data</b-button>
						<b-button class="template-button" @click="sendSecurityCheck" variant="warning">Security</b-button>
						<b-button class="template-button" @click="thanks" variant="success">Thanks</b-button>
						<b-button class="template-button" @click="startClose" variant="warning">Start Close</b-button>
						<b-button class="template-button" @click="close" variant="warning">Close</b-button>
						<br/><br/>
						<b-button class="full-width" @click="endSession" variant="danger">End Live Chat</b-button>
						<br/><br/>
						<div v-if="consent">
							<b-alert variant="success" show>Consent Obtained</b-alert>
							<b-row>
								<b-col><strong>Spending cycle day</strong></b-col><b-col><strong>{{ this.customerBankInfo.spendingCycle.day }}</strong></b-col> 
							</b-row>
							<b-row v-for="a in this.customerBankInfo.accounts" :key="a.id">
								<b-col>{{ a.bank.name }} {{ a.accountType.prettyName }}</b-col><b-col>{{ a.balance }}</b-col>
							</b-row>	
						</div>
						<br/>
						<div class="col-md-12" v-if="consent">
							<table>
								<tr v-for="(value, name) in customer.facts" :key="name">
									<td>{{ name }}</td><td>{{ customer.facts[name] }}</td> 
								</tr>
							</table>
						</div>
						<br/><br/>
						
					</div>
				</div>
			</div>
		</b-overlay>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		session:null,
		customer: null,
		sessions:null,
		working: true,
		interval:null,
		message : { "body": "" },
		self: null,
		consent:false,
		originalMessageCount:0
	}
  },
  methods: {
	getSessions: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/LiveSessions")
			.then((result) => {
				var sessions = result.data;
				for(var x = 0; x < sessions.length; x++)
				{
					sessions[x].startedDateTime = sessions[x].startedDateTime.split('T')[0]  + " " + sessions[x].startedDateTime.split('T')[1].split('.')[0];
				}
				this.sessions = sessions;
				this.working = false;
			}
		)
	},
	getSelf: function() {
		this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000")
			.then((result) => {
				this.self = result.data;
			}
		)
	},
	sendIntro: function() {
		this.message.body = "Hi " + this.customer.person.firstName + ", my name is " + this.self.person.firstName + ", a Money Guide here at Money Guided.  How can I help you today?";
	},
	thanks: function() {
		this.message.body = "Thank you, " + this.customer.person.firstName;
	},
	requestPersonalData: function() {
		this.message.body = this.customer.person.firstName + ", in order for me to better serve you, may I take a look at your personal data? If you give consent, please type 'I consent' exactly as shown.";
	},
	sendSecurityCheck: function() {
		this.message.body = this.customer.person.firstName + ", please provide me with your full name, date of birth and email address.";
	},
	startClose: function() {
		this.message.body = "Is there anything else I can help you with today?";
	},
	close: function() {
		this.message.body = "Thanks for chatting with me today, I hope you found this useful. Have a great day!";
	},
	sendReviewing: function() {
		this.message.body = "Hi " + this.customer.person.firstName + ", my name is " + this.self.person.firstName + ", a Money Guide here at Money Guided.  Please give me a moment to catch up on your messages!";
	},
	sendSetMessage : function(message){
		this.message.body = message;
		this.sendMessage();
	},
	onLoad() {
		this.getSelf();
		this.getSessions();
	},
	forceScroll: function() {
		setTimeout(() => 
			this.$refs["lastMessage"].scrollIntoView({
				behavior: 'smooth',
			})
		, 200);
	},
	selectSession(s){
		this.working = true;
		this.session = s;
		clearInterval(this.interval);
		this.$http.get(this.$config.ApiUri + "/LiveSessions/" + s.id)
			.then((result) => {
				this.session = result.data;
				this.originalMessageCount = this.session.messages.length;
				this.getCustomerData();
				this.interval = setInterval(() => this.refreshMessages(), 5000);
				this.forceScroll();
				this.working = false;
			}
		)
	},
	getCustomerData: function() {
		this.$http.get(this.$config.ApiUri + "/Customers/" + this.session.customerId + "?getFacts=true")
			.then((result) => {
				this.customer = result.data;
			}
		);
		this.$http.get(this.$config.ApiUri + "/Customers/" + this.session.customerId + "/BankAccounts/Info")
			.then((result) => {
				this.customerBankInfo = result.data;
			}
		);
		this.$http.get(this.$config.ApiUri + "/Customers/" + this.session.customerId + "/InvestmentAccounts")
			.then((result) => {
				this.customerInvestments = result.data;
			}
		);
	},
	refreshMessages(){
		this.$http.get(this.$config.ApiUri + "/LiveSessions/" + this.session.id)
			.then((result) => {
				this.session.messages = result.data.messages;
				if (this.session.messages[this.session.messages.length - 1].body == "I consent") {
					this.consent = true;
				}
			}
		)
	},
	endSession(){
		this.$http.delete(this.$config.ApiUri + "/LiveSessions/" + this.session.id)
			.then(() => {
				this.consent = false;
			}
		)
	},
	sendMessage: function() {
		if (this.message.body == "" || this.message.body == null) { return; }
		this.message.customerId = this.session.customerId;
		this.message.whatsApp = true;
		this.message.tag = "LIVEGUIDE," + this.self.id;
		this.message.phoneNumber = this.session.phoneNumber;
		this.$http.post(this.$config.ApiUri + "/Customers/" + this.session.customerId + "/Notifications", this.message)
			.then(() => {
				this.refreshMessages();
				this.message.body = "";
			}
		)
	},
	onSessionSelected(record)
	{
		this.selectSession(record);
	},
	onUnLoad() {
		clearInterval(this.interval);
	}
  },
  mounted: function() { this.onLoad(); },
  destroyed:  function() { this.onUnLoad(); }
}
</script>

<style scoped>
.context-button {

}
.full-width {
	width: 100%;
}
.template-button {
	width: 48%;
	margin:5px;
}
.send-area
{
	b-ottom:0px;
	margin:10px;
	p-osition: fixed;
	width: 95%;
	z-index: 9999;
}

.messages-panel {
	margin-top: 20px;
	margin-bottom: 100px;
}

.message {
	padding: 8px;
	border-radius: 10px !important;
	margin-top: 10px;
	margin-left: 20px;
	margin-right: 20px;
	background-color: #cff3bf;
}
.message div {
	font-size: 10px;
	text-align: right;
}

.message-in{
	margin-right: 100px;
	background-color: rgb(174, 227, 248);
}

.message-out {
	margin-left: 100px;
}

.btn-link
{
	color: #000000 !important;
}

.m0of40
{
	opacity: 0.4;
}

.m1of40
{
	opacity: 0.6;
}

.m2of40
{
	opacity: 0.8;
}
</style>